import type { Production } from '@/api/studio-production'
import { useAuth } from '@/hooks'

/** 项目创建人（与后端 row.UserID 对齐，含 is_owner 与 user_id 回退）。 */
export function useProductionOwner(production: Production | null | undefined): boolean {
  const { user } = useAuth()
  return (
    production?.is_owner === true ||
    (production?.user_id != null && user?.id != null && production.user_id === user.id)
  )
}

/** 仅创建人可执行物理删除；协作者可编辑 / 标记状态。 */
export function useProductionPermissions(production: Production | null | undefined) {
  const isOwner = useProductionOwner(production)
  return { isOwner, canDelete: isOwner }
}
